<template>
  <v-dialog :value="value" width="800px" persistent>
    <v-card>
      <v-card-title>Notes</v-card-title>
      <v-card-text class="black--text">
        <textarea
          :value="notes"
          :style="{ border: '2px solid #000', width: '100%' }"
          rows="10"
          @input="updateNotes($event.target.value)"
        >
        </textarea>
      </v-card-text>
      <v-card-actions>
        <g-button label="Cancel" @onclick="close" />
        <div class="flex-grow-1"></div>
        <g-button label="Save" @onclick="save" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    data: Object,
  },
  data() {
    return {
      notes: "",
    };
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.notes = this.data?.notes || "";
      }
    },
  },
  methods: {
    updateNotes(value) {
      this.notes = value;
    },
    close() {
      this.$emit("input", false);
    },
    save() {
      this.$emit("update", this.notes);
      this.close();
    },
  },
};
</script>
